import whenDomReady from 'when-dom-ready';
import SmartPhoto from 'smartphoto';
// https://appleple.github.io/SmartPhoto/doc.html
function initialise() {
    // Prepare images for lightbox
    const imagesWrappers = document.querySelectorAll('.js-lightbox');
    if (!imagesWrappers)
        return;
    // Default wrapper to be overwritten
    let images = document.querySelectorAll('dummy');
    imagesWrappers.forEach((wrapper) => {
        // Select rich text images in paragraph
        images = wrapper.querySelectorAll('p > img');
    });
    if (typeof images === 'undefined')
        return;
    images.forEach((image) => {
        // Create wrapper container
        const imageWrapper = document.createElement('a');
        imageWrapper.setAttribute('class', 'js-lightbox-link');
        imageWrapper.setAttribute('href', image.src);
        // Insert wrapper before image in the DOM tree
        image.parentNode?.insertBefore(imageWrapper, image);
        // Move image into wrapper
        imageWrapper.appendChild(image);
    });
    // Init image gallery
    new SmartPhoto('.js-lightbox a.js-lightbox-link', {
        nav: false,
    });
}
whenDomReady().then(initialise);
